import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "../notificationSlice";
import { factory } from "../../../api/apiFactory";
const jSuppliersApi = factory.get("jSupplier");
const initialState = {
  searchBody: {},
  jSupplier: {
    loading: false,
    dialog: false,
    active: false,
    form: {
      id: "",
      name: "",
      note: "",
    },
  },
  jSuppliers: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
  },
  jSuppliersList: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const jSuppliersSlice = createSlice({
  name: "jSupplier",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.jSupplier.dialog = !state.jSupplier.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.jSuppliers.data = payload.data.data;
      state.jSuppliers.total = payload.data.total;
      state.jSuppliers.total_amount = payload.data.total_amount;
    },
    setDataList: (state, { payload }) => {
      state.jSuppliersList.data = payload.data.data;
    },
    setById: (state, { payload }) => {
      state.jSupplier.form = payload;
    },
    setLoading: (state, action) => {
      state.jSuppliers.loading = !state.jSuppliers.loading;
    },
    resetForm: (state, action) => {
      state.jSupplier.form = initialState.jSupplier.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
  setDataList,
} = jSuppliersSlice.actions;

export default jSuppliersSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("jSupplier"));
    const res = await jSuppliersApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("jSupplier"));
  } catch (err) {
    dispatch(setLoading("jSupplier"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getAllList = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("jSupplier"));
    const res = await jSuppliersApi.getAllList(params);
    dispatch(setDataList(res));
    dispatch(setLoading("jSupplier"));
  } catch (err) {
    dispatch(setLoading("jSupplier"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteById = (id, _SearchBody) => async (dispatch) => {
  try {
    await jSuppliersApi.delete(id);
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      })
    );
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id, forUpdate) => async (dispatch) => {
  try {
    dispatch(setLoading("jSupplier"));
    const res = await jSuppliersApi.getById(id);
    dispatch(setById(res.data.data[0]));
    if (forUpdate) {
      dispatch(setDialog());
    }
    dispatch(setLoading("jSupplier"));
  } catch (err) {
    dispatch(setLoading("jSupplier"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const create = (data, _SearchBody) => async (dispatch) => {
  try {
    const res = await jSuppliersApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الاضافة بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
    return Promise.resolve(res);
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (id, data, _SearchBody) => async (dispatch) => {
  try {
    const res = await jSuppliersApi.update(id, data);
    dispatch(
      showNotification({
        message: "تم تعديل المنتج بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
    return Promise.resolve(res);
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const JSupplier = {
  getAll,
  deleteById,
  getById,
  create,
  update,
  getAllList,
};
